// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Lm-z","modalContent":"Mm-z","header":"Nm-z","close":"Om-z"};